export const INTERACTION_PAYWALL_ID = 'interaction-paywall';
